<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    rowCount?: number
  }>(),
  {
    rowCount: 15
  }
)
</script>

<template>
  <div class="friend-link-skeleton-list" aria-hidden="true">
    <article v-for="idx in props.rowCount" :key="idx" class="friend-link-skeleton-item">
      <span class="friend-link-skeleton-logo skeleton-block" />
      <div class="friend-link-skeleton-main">
        <span class="friend-link-skeleton-title skeleton-block" />
        <span class="friend-link-skeleton-desc skeleton-block" />
      </div>
    </article>
  </div>
</template>

<style scoped>
.friend-link-skeleton-list {
  --skeleton-bg: color-mix(in srgb, var(--line) 74%, var(--bg) 26%);
  --skeleton-glow: color-mix(in srgb, var(--bg) 70%, var(--skeleton-bg) 30%);
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.friend-link-skeleton-item {
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  padding: 10px;
  border-radius: var(--radius);
  background: var(--bg);
}

.friend-link-skeleton-main {
  min-width: 0;
  display: grid;
  gap: 8px;
}

.friend-link-skeleton-logo {
  width: 48px;
  height: 48px;
  border-radius: 8px;
}

.friend-link-skeleton-title {
  width: 76%;
  height: 14px;
  border-radius: 8px;
}

.friend-link-skeleton-desc {
  width: 94%;
  height: 12px;
  border-radius: 8px;
}

.skeleton-block {
  position: relative;
  overflow: hidden;
  background: var(--skeleton-bg);
}

.skeleton-block::after {
  content: '';
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(100deg, transparent 16%, var(--skeleton-glow) 50%, transparent 84%);
  animation: skeleton-shimmer 1.8s ease-in-out infinite;
}

@keyframes skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton-block::after {
    animation-duration: 0.01ms;
    animation-iteration-count: 1;
  }
}

@media (max-width: 760px) {
  .friend-link-skeleton-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 520px) {
  .friend-link-skeleton-list {
    grid-template-columns: 1fr;
  }
}
</style>
